import React from 'react';
import LoadingSpinner from 'components/LoadingSpinner';

interface MapLoadingPlaceholderProps {
  /** Whether the map it stands in for is still hidden. */
  show: boolean;
}

/**
 * Fills a property map's area while the map is hidden waiting for its first
 * fit, so the wait reads as loading rather than as an empty panel. Fades out
 * as the map fades in. Rendered as a sibling of the map container, inside a
 * relatively positioned parent.
 */
const MapLoadingPlaceholder: React.FC<MapLoadingPlaceholderProps> = ({
  show
}) => (
  <div
    data-testid="map-loading-placeholder"
    aria-hidden={!show}
    className={`absolute inset-0 z-10 flex items-center justify-center bg-neutral-10 transition-opacity duration-300 ${
      show ? 'opacity-100' : 'opacity-0 pointer-events-none'
    }`}
  >
    {show && <LoadingSpinner message="" label="Loading map" />}
  </div>
);

export default MapLoadingPlaceholder;
